import React, { useState, useEffect } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer"
import Slider from "../../components/Slider/Slider";
import { ReactSVG } from "react-svg";
import { useNavigate } from "react-router-dom";


const Home = () => {
    const navigate = useNavigate();
    const [menuToggle, setMenuToggle] = useState(false);
    // number effect
    const [scrollNumber, setScrollNumber] = useState(false);
    const [number, setNumber] = useState(0);
    const [number1, setNumber1] = useState(0);

    // const ref = useRef(null);


    const solution = [
        {
            icon: 'appointment',
            title: '快速預約',
            content: '數位預約系統進行快速且自動化的預約，預約同時建立顧客資料',
        }, {
            icon: 'pay',
            title: '輕鬆結帳',
            content: '線上金流串接與支援 iPhone 卡緊收與開立發票，提供流暢的支付體驗',
        }, {
            icon: 'pos',
            title: '智能POS機',
            content: '整合系統和自動化工具，可以進行預約、添加商品、結帳與會員管理',
        }, {
            icon: 'market',
            title: '行銷傳播',
            content: '精準的會員分眾營銷，提升顧客忠誠度，創造最大營銷效果',
        }, {
            icon: 'shop',
            title: '庫存和線上商店',
            content: '設置自己的線上商店，整合多分店庫存，狀態即時更新',
        }, {
            icon: 'data-analysis',
            title: '數據分析報表',
            content: '利用數據分析工具，數位化經營強化私域流量，推動銷售加速成長',
        },
    ]

    const features = [
        {
            img: 'phone-view',
            feature: '線上預約',
            title: '自動化預約流程\n\n專為忙碌專業人士和企業打造',
            content: '在 RevX 平台上建立您的網店，並且將網址加在您的 Google 地圖商家的「線上預訂」\n讓新客戶或現有客戶能夠立即線上進行預約服務，更容易接觸到附近的潛在客戶群。',
            list: [
                '享受平台流量，連結廣大的用戶群',
                '3秒完成快速線上預約，自動發送提醒',
                '鼓勵用戶分享購物體驗評論與評分',
            ]
        },
        {
            img: 'phone-view-1',
            feature: '品牌點數',
            title: '專屬會員回饋計劃 兌換生活化實用商品',
            content: '品牌數位化會員，透過集點的玩法打造強大會員募集，透過點數兌換7-11、全家、家樂福等生活化實用商品，提升顧客忠誠度與持續支持你的品牌！',
            list: [
                '賺取點數或兌換等互動吸引潛在客戶',
                '可兌換7-11、全家、家樂福等生活化商品',
                '提升顧客的忠誠度和回購率',
            ]
        },
        // {
        //     img: 'web-view-1',
        //     feature: '智能化行銷',
        //     title: '精準吸引核心客群 深化顧客關係',
        //     content: '透過先進的 AI 分析工具，描繪出顧客輪廓，更加精準剖析放與個性化的服務。\n\n利用 RevX 智能化行銷策略，讓顧客感受到個人化的尊榮和獎勵，提升顧客忠誠度與持續支持品牌。',
        //     list: [
        //         '為顧客貼上標籤，掌握顧客狀態',
        //         '智慧推播，獨家行銷推播給特定客群',
        //         '提供個性化福利，強化客戶關係',
        //     ]
        // }
    ]

    const businessType = [
        {
            icon: 'hair',
            title: '美髮沙龍',
        }, {
            icon: 'nail',
            title: '美甲美睫',
        }, {
            icon: 'weight',
            title: '健身瑜伽',
        }, {
            icon: 'medicine',
            title: '醫美診所',
        }, {
            icon: 'massage',
            title: 'SPA按摩',
        }
    ]

    // 點擊外部區域關閉menu
    // useEffect(() => {
    //     function handleClickOutside(e) {
    //         if (ref.current && !ref.current.contains(e.target)) {
    //             setMenuToggle(false)
    //         }
    //     }

    //     document.addEventListener("mousedown", handleClickOutside);
    //     return () => {
    //         document.removeEventListener("mousedown", handleClickOutside);
    //     }
    // }, [])

    // 回到最頂部
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])


    // 滾動特效

    useEffect(() => {

        // 觸發開關
        const handleScroll = () => {

            // Get the scroll position
            const scrollY = window.scrollY || document.documentElement.scrollTop;
            // console.log('window.scrollY', window.scrollY)
            // console.log(document.documentElement.scrollTop)

            const increasing = document.getElementsByClassName('increasing');

            // console.log('window.innerHeight', window.innerHeight)

            // Define a threshold for triggering the effect
            const scrollThreshold = increasing[0].offsetTop - window.innerHeight;
            // console.log('scrollThreshold', scrollThreshold)


            // Update the state based on the scroll position
            setScrollNumber(scrollY > scrollThreshold);

        }

        if (scrollNumber && number < 12000) {
            const timer = setInterval(() => {
                setNumber(n => n + 30);
            }, 0.7)
            return () => {
                clearInterval(timer)
            }
        }
        if (scrollNumber && number1 < 10000) {
            const timer = setInterval(() => {
                setNumber1(n => n + 40);
            }, 0.7)
            return () => {
                clearInterval(timer)
            }
        }
        if (number > 12000) {
            setScrollNumber(false)
        }


        // Add the event listener when the component mounts
        window.addEventListener('scroll', handleScroll);

        // Remove the event listener when the component unmounts
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };

    }, [number, number1, scrollNumber])

    return (
        <div className="revx-wrapper">
            <Header
                setMenuToggle={setMenuToggle}
                menuToggle={menuToggle}
            />
            <div className="home" onClick={() => { setMenuToggle(false) }}>
                <div className="banner home-banner">
                    <div className="dec"></div>
                    <h1 className="m-3">全亞洲最快速的專業預約</h1>
                    <p className="m-4 text-center">簡化預約流程和良好的體驗，結合不同的業務需求，提升操作上的便利性！</p>
                    <button className="color-btn m-4" onClick={() => navigate('/user-flow')}>
                        開始體驗
                    </button>
                    <div className="banner-img">
                        <img className="home-banner-img" src={process.env.PUBLIC_URL + '/img/home/web-phone-view.svg'} alt='web view' />
                    </div>
                </div>
                <div className="home-content">
                    <section className="destination bg-grad  lg:flex-row">
                        <div className="title">
                            <h2>讓預約變簡單<br />重塑商業效率新維度</h2>
                            <p className="text-justify">加入 RevX 共享生活化平台，享受現成的平台流量無需從零開始！<br />連結廣大的用戶群，更是快速增長的加速器。</p>
                        </div>
                        <div className="number">
                            <ul className="lg:flex">
                                <li>
                                    {/* 可以做之前的數字動畫 */}
                                    <h2 id="value1" className="increasing">{number}+</h2>
                                    <p>平台會員</p>
                                </li>      <li>
                                    <h2 className="number">{number1}+</h2>
                                    <p>預約次數</p>
                                </li>

                            </ul>
                        </div>
                    </section>
                    <section className="solution">
                        <div className="top">
                            <h2>為您的企業數位轉型 一站式整合預約、會員、POS</h2>
                            <p className="text-justify">直觀的介面和一站式流程體驗，並即時掌握關鍵數據，系統 AI 自動生成報表，利用數據化策略，推動銷售加速成長，實現商業創新與數位轉型。</p>
                        </div>
                        <ul>
                            {
                                solution.map((item, index) => {
                                    return (
                                        <li key={index} className="bg-light-grad">
                                            <div className="solution-title">
                                                <ReactSVG src={process.env.PUBLIC_URL + '/img/icon/solution/' + item.icon + '.svg'} />
                                                <h5>{item.title}</h5>
                                            </div>

                                            <p>{item.content}</p>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </section>
                    <section className="features">
                        <ul>
                            {
                                features.map((item, index) => {
                                    return (
                                        <li key={index} className="features-list">
                                            <div className="img">
                                                <img src={process.env.PUBLIC_URL + '/img/home/' + item.img + '.png'} alt={item.title} />
                                            </div>
                                            <div className="content">
                                                <h5 className="">{item.feature}</h5>
                                                <h3 className="mb-4 mt-4">{item.title}</h3>
                                                <p className="pt-3 pb-3">{item.content}</p>
                                                <ul>
                                                    {item.list.map((i, index) => {
                                                        return (
                                                            <li key={index}>
                                                                <ReactSVG src={process.env.PUBLIC_URL + '/img/icon/check.svg'} />
                                                                <p className="ms-3">{i}</p>
                                                            </li>
                                                        )
                                                    })}
                                                </ul>
                                            </div>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </section>
                    {/* review */}
                    <Slider />
                </div>

                <section className="business-type">
                    <div className="price-area">
                        <h2 className="mb-4">數位轉型 從這裡開始</h2>
                        <button className="shadow-btn" onClick={() => { navigate('/pricing') }}>查看方案價格</button>
                    </div>
                    <div className="business-type-content">

                        {/* <ReactSVG className="crew" src={process.env.PUBLIC_URL + '/img/home/crew.svg'} /> */}
                        <img className="crew" src={process.env.PUBLIC_URL + '/img/home/crew-1.svg'} alt="員工" />
                        <h2 className="m-4">如果你是以下類型的企業</h2>
                        <p className="text-justify">
                            為客戶提供了一個自主且客製化的工具有效管理，實現商業創新與數位轉型！<br />數位化經營會員，強化私域流量，透過數據了解其產品在目標受眾中的影響力。
                        </p>
                        <ul className="justify-start md:justify-between">
                            {businessType.map((item, index) => {
                                return (
                                    <li key={index} className="p-4 bg-light-grad cursor-pointer" onClick={() => { navigate('/user-flow') }}>
                                        <ReactSVG src={process.env.PUBLIC_URL + '/img/icon/industry/' + item.icon + '.svg'} />
                                        <p>{item.title}</p>
                                    </li>
                                )
                            })
                            }
                        </ul>
                    </div>

                </section>

            </div>


            <Footer />
        </div>
    )
}

export default Home;